import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
// import { svgSprite } from '../../../../../hybrid/wrappers';
// import InputItemCustom from '../InputItem/InputItemCustom';
// import FormSelect from '../../form-dropdown/FormDropdown/FormDropdown';
// import FormCheckbox from '../../form-checkbox/FormCheckbox/FormCheckbox';
import { t } from '../../../../../common/components/T';
import { useWidgetTranslates } from '../../../../../common/utils/utils';
import css from './FormProductPrices.module.scss';
import classnames from 'classnames';
import UserContext, { UserProfileContext } from '../../../../../common/utils/getContext';
import { getData } from '../../../../../common/utils/router';
import FormInput from '../../form-input/FormInput/FormInput';

const FormProductPricesCustom = ({ attribute, value = [], setFormData, errors, isAdditionalProduct, is_page_edit }) => {
    const { userToken, lang } = useContext(UserContext);
    const { roles } = useContext(UserProfileContext);
    const [allCurrencies, setAllCurrencies] = useState([]);
    const [currencies, setCurrencies] = useState([]);
    const mainPVCurrency = useMemo(() => {
        return allCurrencies?.find((currency) => currency?.main);
    }, [allCurrencies]);

    const hasAccess = useMemo(() => {
        if (!roles || !roles?.length) return false;
        return is_page_edit ? ['admin', 'superadmin'].some((role) => roles?.find((role2) => role === role2?.name)) : true;
    }, [roles, is_page_edit]);

    useEffect(() => {
        getData('/api/v1/admin/finance/currencies?filter[status]=active&page[size]=99', userToken, lang).then((res) => {
            setAllCurrencies(res?.data);
            setCurrencies(
                res?.data
                    ?.filter((curr) => {
                        if (curr?.type?.value === 'marketing') return false;
                        return true;
                    })
                    ?.map((curr) => ({
                        ...curr,
                        label: curr?.code
                    }))
            );
        });
    }, [userToken, lang]);

    // useEffect(() => {
    //     if (isAdditionalProduct) {
    //         setFormData('prices', []);
    //     } else {
    //         setFormData('prices', [
    //             {
    //                 currency_id: 1,
    //                 marketing_currency_id: 17,
    //                 price_for_client: "",
    //                 price_for_partner: "",
    //                 product_count_from: "1",
    //                 scores_for_client: ""
    //             }
    //         ]);
    //     }
    // }, [isAdditionalProduct])

    const changeHandler = useCallback(
        (key, v, currency) => {
            if (isAdditionalProduct) {
                const isExist = value?.find((cur) => cur?.currency_id === currency?.id);
                if (isExist) {
                    const newValue =
                        v == 0
                            ? value?.filter((prevValue) => {
                                  if (currency?.id === prevValue.currency_id) {
                                      return false;
                                  }
                                  return true;
                              })
                            : value?.map((prevValue) => {
                                  if (prevValue?.currency_id === currency?.id) {
                                      return {
                                          ...prevValue,
                                          price_for_client: v,
                                          price_for_partner: v,
                                          scores_for_client: ''
                                      };
                                  }
                                  return prevValue;
                              });
                    setFormData(attribute, newValue);
                } else {
                    setFormData(attribute, [
                        ...(value || []),
                        {
                            currency_id: currency?.id,
                            price_for_client: v,
                            price_for_partner: v,
                            scores_for_client: '',
                            product_count_from: '1'
                        }
                    ]);
                }
            } else {
                setFormData(attribute, [
                    {
                        currency_id: mainPVCurrency?.id,
                        price_for_client: v,
                        price_for_partner: v,
                        scores_for_client: '',
                        product_count_from: '1'
                    }
                ]);
            }
        },
        [isAdditionalProduct, value, mainPVCurrency]
    );

    // const [mark, setMark] = useState(
    //     value && value.length > 0 && value[0].price_for_client === value[0].scores_for_client ? '1' : '0'
    // );
    // const mark = '1';
    const transl = useWidgetTranslates('form');
    // const setMarkData = (attr, v) => {
    //     if (v === '0') {
    //         setFormData(attribute, value);
    //     } else {
    //         setFormData(
    //             attribute,
    //             value.map((item) => {
    //                 const accum = {
    //                     scores_for_client: item['price_for_client'],
    //                     marketing_currency_id: dataCurrency?.marketing_currency.value
    //                 };
    //                 Object.keys(item).forEach((key) => {
    //                     if (key !== 'marketing_currency_id' && key !== 'scores_for_client') {
    //                         accum[key] = item[key];
    //                     }
    //                 });
    //                 return accum;
    //             })
    //         );
    //     }
    //     setMark(v);
    // };

    // const [disable, setDisable] = useState(false);
    const filterError = {};
    for (let key in errors) {
        const item = key.includes('prices');
        if (item) {
            filterError[key] = errors[key];
        }
    }
    let errorPrices = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
    for (let key in filterError) {
        const id = Number(key.substring(7, 8));
        const value = key.substring(9);
        errorPrices[id][value] = filterError[key];
    }
    // const addDiapason = () => {
    //     if (value.length > 10) {
    //         setDisable(true);
    //     } else {
    //         if (mark === '1') {
    //             setFormData(attribute, [
    //                 ...value,
    //                 {
    //                     currency_id: dataCurrency?.currency.value,
    //                     product_count_from: '1',
    //                     price_for_client: '',
    //                     price_for_partner: '',
    //                     marketing_currency_id: dataCurrency?.marketing_currency.value,
    //                     scores_for_client: ''
    //                 }
    //             ]);
    //         } else if (mark === '0') {
    //             setFormData(attribute, [
    //                 ...value,
    //                 {
    //                     currency_id: dataCurrency?.currency.value,
    //                     marketing_currency_id: dataCurrency?.marketing_currency.value,
    //                     product_count_from: '1',
    //                     price_for_client: '',
    //                     scores_for_client: '',
    //                     price_for_partner: ''
    //                 }
    //             ]);
    //         }
    //     }
    // };
    // const deleteDiapason = (idx, mark) => {
    //     if (mark) {
    //         const oldArr = value.filter((el) => el.currency_id !== dataCurrency?.currency.value);
    //         const newArr = value
    //             .filter((el) => el.currency_id === dataCurrency?.currency.value)
    //             .filter((el) => el.marketing_currency_id === dataCurrency?.marketing_currency.value);
    //         newArr.splice(idx, 1);
    //         setFormData(attribute, [...oldArr, ...newArr]);
    //     } else {
    //         const oldArr = value.filter((el) => el.currency_id !== dataCurrency?.currency.value);
    //         let newArr = value.filter((el) => el.currency_id === dataCurrency?.currency.value);
    //         newArr.splice(idx, 1);
    //         setFormData(attribute, [...oldArr, ...newArr]);
    //     }
    // };
    // let modernOptions = [];
    // if (mark === '0') {
    //     modernOptions = options;
    // } else {
    //     options.map((opt) => {
    //         if (opt.alias === 'product_count_from' || opt.alias === 'price_for_client' || opt.alias === 'price_for_partner') {
    //             modernOptions.push(opt);
    //         }
    //     });
    // }

    return (
        <div>
            <div className={css.formProductPricesHeaderWrapper}>
                {isAdditionalProduct ? (
                    <div>
                        {currencies?.map((curr, idx) => (
                            <FormInput
                                key={curr?.id}
                                attribute={`prices_${idx}`}
                                placeholder={'0'}
                                title={{ body: curr?.code }}
                                setFormData={(k, v) => changeHandler(k, v, curr)}
                                typeField='number'
                                value={value?.filter((i) => i.currency_id == curr?.id)?.[0]?.price_for_client}
                                errors={Object.keys(filterError || {})?.reduce((acc, key) => {
                                    const errorIdx = +key?.split('.')[1];
                                    const isCurrencyError = value[errorIdx]?.currency_id === curr?.id;
                                    if (isCurrencyError) {
                                        filterError[key]?.map((error) => {
                                            acc.push(error);
                                        });
                                    }
                                    return acc;
                                }, [])}
                                disabled={!hasAccess}
                            />
                        ))}
                    </div>
                ) : (
                    <FormInput
                        attribute={`prices_0`}
                        placeholder={'0'}
                        title={{ body: t('price_at_pv', 'Стоимость, PV', 'widget', transl, 'form') }}
                        setFormData={(k, v) => changeHandler(k, v, mainPVCurrency)}
                        typeField='number'
                        disabled={!hasAccess}
                        // errors={Object.keys(filterError || {})?.reduce((acc, key) => {
                        //     const errorIdx = +key?.split('.')[1];
                        //     const isCurrencyError = value[errorIdx]?.currency_id === mainPVCurrency?.id;
                        //     if (isCurrencyError) {
                        //         filterError[key]?.map((error) => {
                        //             acc.push(error);
                        //         })
                        //     }
                        //     return acc;
                        // }, [])}
                        errors={errors?.prices}
                        value={value?.[0]?.price_for_client}
                    />
                )}
                {/* {isAdditionalProduct ? (
                 <div className={css.formProductPricesHeaderItem}>
                 <FormSelect
                 compStyle={{
                 wrapper: {
                 className: css.formProductPricesWrapper,
                 justifyContent: 'flex-start !important'
                 }
                 }}
                 type='dropdown'
                 attribute='currency_id'
                 default_value='1'
                 disabled={false}
                 hint={null}
                 options={currencies || []}
                 noTranslate={true}
                 placeholder={t('form-ChooseCurrency', 'Выберите валюту', 'widget', transl, 'form')}
                 required={false}
                 title={{
                 body: t('form-currency', 'Валюта', 'widget', transl, 'form')
                 }}
                 setFormData={setFormData}
                 handlers={{
                 onChange: (e) => {
                 setDataCurrency({
                 ...dataCurrency,
                 currency: e
                 });
                 }
                 }}
                 errors={errors['prices']}
                 // value={dataCurrency?.currency}
                 />
                 </div>
                 ) : null} */}
                {/* {isAdditionalProduct ? null : (
                 <div>
                 <FormCheckbox
                 compStyle={{
                 wrapper: { className: classnames(css.formProductPricesWrapper, css.dn) }
                 }}
                 attribute='mark_check'
                 type='checkbox'
                 disabled={defaultDataCurrency?.marketing_currency?.value == undefined}
                 hint={null}
                 required={true}
                 title={{
                 body: t(
                 'form-MarketingPrice-new',
                 'Маркетинговая стоимость соответствует цене',
                 'widget',
                 transl,
                 'form'
                 )
                 }}
                 setFormData={setMarkData}
                 handlers={{}}
                 value={mark}
                 />
                 </div>
                 )} */}
            </div>
            <div className={classnames(css.formProductPrices)}>
                {/* Web */}
                {/* <div className={classnames(css.formProductPricesColTabs)}>
                 {modernOptions.map((option, idx) => {
                 return (
                 <div className={classnames(css.formProductPricesColTabsItem)} key={`option${idx}`}>
                 {option.title}
                 </div>
                 );
                 })}
                 </div> */}
                {/* {value ? (
                 value
                 .filter((e) => e.currency_id === dataCurrency?.currency.value)
                 .map((item, index) => (
                 <div key={`item${index}`} className={classnames(css.formProductPricesCol)}>
                 {!!index && (
                 <div className={css.formProductPricesColClose} onClick={() => deleteDiapason(index)}>
                 {svgSprite('cross', {
                 className: css.formCheckboxSvg
                 })}
                 </div>
                 )}
                 {modernOptions.map((option, idx) => {
                 return (
                 <InputItemCustom
                 value={value}
                 key={`optionss${idx}`}
                 attribute={attribute}
                 setFormData={setFormData}
                 handlers={handlers}
                 required={required}
                 disabled={disabled}
                 errors={
                 Object.keys(errorPrices[index]).length !== 0
                 ? errorPrices[index][option.alias]
                 : []
                 }
                 option={option}
                 index={index}
                 idx={idx}
                 currency={dataCurrency?.currency}
                 setDataCurrency={setDataCurrency}
                 mark={mark}
                 />
                 );
                 })}
                 </div>
                 ))
                 ) : value && dataCurrency?.currency && dataCurrency?.marketing_currency ? (
                 value
                 .filter((e) => e.currency_id === dataCurrency?.currency.value)
                 .map((item, index) => (
                 <div key={`item${index}`} className={classnames(css.formProductPricesCol)}>
                 {!!index && (
                 <div className={css.formProductPricesColClose} onClick={() => deleteDiapason(index, true)}>
                 {svgSprite('cross', {
                 className: css.formCheckboxSvg
                 })}
                 </div>
                 )}
                 {modernOptions.map((option, idx) => {
                 return (
                 <InputItemCustom
                 value={value}
                 key={`optionss${idx}`}
                 attribute={attribute}
                 setFormData={setFormData}
                 handlers={handlers}
                 required={required}
                 disabled={disabled}
                 errors={
                 Object.keys(errorPrices[index]).length !== 0
                 ? errorPrices[index][option.alias]
                 : []
                 }
                 option={option}
                 index={index}
                 idx={idx}
                 currency={dataCurrency?.currency}
                 setDataCurrency={setDataCurrency}
                 />
                 );
                 })}
                 </div>
                 ))
                 ) : (
                 <div className={classnames(css.formProductPricesCol)}>
                 {modernOptions.map((option, idx) => {
                 return (
                 <InputItemCustom
                 value={[]}
                 key={`optionss${idx}`}
                 attribute={attribute}
                 setFormData={setFormData}
                 handlers={handlers}
                 required={required}
                 disabled={true}
                 option={option}
                 index={1}
                 idx={idx}
                 currency={dataCurrency?.currency}
                 setDataCurrency={setDataCurrency}
                 />
                 );
                 })}
                 </div>
                 )} */}
                {/* {((value && dataCurrency?.currency && mark === '1') ||
                 (value && dataCurrency?.currency && dataCurrency?.marketing_currency)) &&
                 value.filter((e) => e.currency_id === dataCurrency?.currency.value).length === 0 ? (
                 <div className={css.formProductPricesAdd} onClick={disable ? () => {} : () => addDiapason()}>
                 {svgSprite('plus', {
                 width: 14,
                 height: 14,
                 fill: 'var(--blueColor)'
                 })}
                 </div>
                 ) : (
                 <></>
                 )} */}
            </div>
        </div>
    );
};
FormProductPricesCustom.propTypes = {
    attribute: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    handlers: PropTypes.object,
    value: PropTypes.array,
    setFormData: PropTypes.func,
    errors: PropTypes.array,
    options: PropTypes.array,
    currencies: PropTypes.array,
    marketing_currencies: PropTypes.array,
    defaultDataCurrency: PropTypes.object
};
export default FormProductPricesCustom;
